// extracted by mini-css-extract-plugin
export default {"wam-color-drawer":"drawer-container_wam-color-drawer__gZBMw"};